import Config from '../definitions/Config';
import fetchJSON from './fetchJSON';
import noticeError from './noticeError';


const CITIES_API_URL = Config.CITIES_API_URL;

/**
 * Retrieve city information.
 * @param {object} city - city object which contains various identifying data
 * @param {number} city.id - id of city
 * @param {string} city.slug - city slug
 * @param {string} city.name - the name of the city
 * @param {string} city.province - province code where the city is located
 * @param {string} callerName name of the caller when generating Error messages
 * @returns {object}
 */
async function fetchCityInformation(city, callerName) {
    try {
        const params = city.id
            ? {
                cityId: city.id,
            }
            : {
                city: city.slug ?? city.name,
                ...city.province && { province: city.province },
            };

        if (!params.cityId && !params.city) {
            const error = new Error('[fetchCityInformation] must receive either cityId by itself or city with optional province');

            noticeError(error, {
                city,
                params,
            });

            throw error;
        }

        const target = {
            url: CITIES_API_URL,
            params: params,
        };

        const response = await fetchJSON(target, callerName);

        // ASSUMPTION: if the response has a .data, then we are assuming it's the new API format.
        return response.data ?? response;
    } catch (e) {
        // eslint-disable-next-line
        console.error(`${callerName} failure while calling cities api`, e);
        throw new Error(e);
    }
}

export default fetchCityInformation;